import React, { useEffect, useRef, useState } from "react";
import { connect } from "../../base/redux";
import { translate } from "../../base/i18n";

import { getVideoInputDeviceData } from "../../base/devices";
import { SelectDevice } from "./DeviceSelect";
import { setVideoMuted } from "../../base/media";
import { StyledLayoutContainer } from "../../video-layout-mode/styled";
import { BsCameraVideoOff } from "react-icons/bs";

let initStatus = {
    type: "ok",
    message: "device.cameraOk"
};

function SelectVideoInput({ 
    t, dispatch, list, isRoom,
    didMount, cameraId, setSelectVdo
}) {
    const element = useRef();
    const [currentStream, setCurrentStream] = useState(null);
    const [status, setStatus] = useState(initStatus);

    useEffect(() => {
        if (didMount) setCameraTrack();
    }, [cameraId]);

    useEffect(() => {
        if (didMount) setCameraTrack();
        else stopMediaTracks(currentStream);
    }, [didMount]);

    useEffect(() => {
        if (currentStream && currentStream.active) element.current.srcObject = currentStream;

        return () => {
            if (typeof currentStream !== 'undefined' && currentStream) {
                stopMediaTracks(currentStream);
            }
        }
    }, [currentStream]);

    const stopMediaTracks = (stream) => {
        stream && stream.getTracks().forEach(track => {
            track.stop();
        });
    }

    const setCameraTrack = async () => {        
        APP.UI.showLoading(true);

        if (typeof currentStream !== 'undefined' && currentStream) {
            stopMediaTracks(currentStream);
        }

        navigator.mediaDevices.getUserMedia({
            video: { deviceId: cameraId }, 
            audio: false
        }).then(stream => {
            setCurrentStream(stream);

            const streamId = stream.getTracks()[0].getSettings().deviceId;
            if (cameraId !== streamId) setSelectVdo(streamId);
            setStatus(initStatus);

            APP.UI.showLoading(false);
        }).catch(async err => {
            console.log(err);
            const status = await APP.mateManagement.getVdoErrorMsg(err);

            setStatus(status);

            APP.UI.showLoading(false);
        });
    }

    const _setVideoMuted = e => {    
        dispatch(setVideoMuted(e.target.checked));
    };

    return (
        <>
            <dt> { t("device.cameraSetting") } </dt>
            
            { currentStream && currentStream?.active ?
                <StyledLayoutContainer className={"video_input"} isLocal={true}>
                    <video ref={element} id="localVideo" autoPlay playsInline controls={false}/>
                </StyledLayoutContainer>
                : <dd className={"video_input"}>
                    <div className="default"> 
                        <dl className="center">
                            <BsCameraVideoOff color={"#fff"} />
                        </dl>
                    </div>
                </dd> }
            
            <SelectDevice 
                t={t}
                list={list} 
                deviceId={cameraId} 
                setDeviceId={(id) => setSelectVdo(id)} 
                deviceStatus={status}
            />
            { !isRoom && <dd className="mute_check nonSelect">
                <input type="checkbox" onChange={_setVideoMuted} id="videoMuteBtn" disabled={status.type === 'ok' ? false : true} />
                <label htmlFor="videoMuteBtn">
                    <span>{t("device.hideVideo")}</span>
                </label>
            </dd>}            
        </>
    )
}

function _mapStateToProps(state) {
    const list = getVideoInputDeviceData(state); 
    
    return {
        list
    }
}

export default translate(connect(_mapStateToProps)(SelectVideoInput));